import { makeAutoObservable } from "mobx";
import { RSet } from "../collections";
import { NotAvailableFulfillmentMethod } from "./NotAvailableFulfillmentMethod";
import { NotAvailableNowLabel } from "./NotAvailableNowLabel";
import { OrderForLabel } from "./OrderForLabel";
import { TemporarilyUnavailableLabel } from "./TemporarilyUnavailableLabel";
const labelCreators = [
    TemporarilyUnavailableLabel.createLabel(),
    NotAvailableNowLabel.createLabel(),
    NotAvailableFulfillmentMethod.createLabel(),
    OrderForLabel.createLabel(),
];
export class LabelsCreator {
    constructor(params) {
        this.productInstanceAvailabilityService =
            params.productInstanceAvailabilityService;
        this.productInstancePreorderSettingsService =
            params.productInstancePreorderSettingsService;
        this.fulfillmentTimeScope = params.fulfillmentTimeScope;
        this.productInstances = params.productInstances;
        this.view = params.view;
        makeAutoObservable(this);
    }
    get intersectAvailabilityReasonsForAllProductInstance() {
        const reasonArr = this.productInstances.map((productInstance) => this.productInstanceAvailabilityService.availability(productInstance)
            .unavailabilityReasons);
        return reasonArr.length > 0
            ? reasonArr
                .slice(1)
                .reduce((acc, el) => acc.intersection(el), reasonArr[0])
            : RSet.empty();
    }
    get labels() {
        const reasons = this.intersectAvailabilityReasonsForAllProductInstance;
        return labelCreators
            .map((labelCreator) => {
            return labelCreator({
                fulfillmentTime: this.fulfillmentTimeScope.fulfillmentTime,
                reasons,
                productInstances: this.productInstances,
                view: this.view,
                productInstancePreorderSettingsService: this.productInstancePreorderSettingsService,
            });
        })
            .filter((label) => label !== null);
    }
}
